module.exports = __webpack_public_path__ + "img/diaoyun-operator-bg.ac33bb58.jpg";